import { useMemo } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player";
import { useTranslation } from "react-i18next";

import Header from "../components/Header";
import Social from "../components/Social";
import Breadcrumb from "../components/Breadcrumb";
import NotFoundPage from "./NotFound";
import Seo from "../components/Seo";

type WorkoutEntry = {
    title: string
    videoUrl: string
    blocks: WorkoutBlock[]
    seoDescription: string
}

type WorkoutBlock =
    | { kind: "p"; text: string }
    | { kind: "h"; text: string }
    | { kind: "ul"; items: string[] };

const mfrBlocks: WorkoutBlock[] = [
    {
        kind: "p",
        text: "МФР с шариком (миофасциальный релиз) — это эффективная техника самомассажа, направленная на снятие мышечных зажимов, улучшение подвижности тела и ускорение восстановления после нагрузок. В отличие от классического массажа, МФР воздействует не только на мышцы, но и на фасции — соединительную ткань, которая окутывает мышцы и может вызывать ощущение скованности, боли и ограничение движений."
    },
    {
        kind: "h",
        text: "Что такое МФР и как он работает"
    },
    {
        kind: "p",
        text: "Миофасциальный релиз с шариком основан на точечном давлении на триггерные точки — участки перенапряжения в мышцах. При аккуратном надавливании улучшается кровообращение, снижается мышечный спазм и восстанавливается нормальная длина мышечных волокон. Это помогает телу быстрее расслабиться и вернуться в функциональное состояние."
    },
    {
        kind: "h",
        text: "Польза МФР с шариком"
    },
    {
        kind: "ul",
        items: [
            "уменьшение мышечной боли и зажимов (в спине, шее, ягодицах, ногах)",
            "снятие напряжения после тренировок и сидячего образа жизни",
            "улучшение гибкости и подвижности суставов",
            "ускорение восстановления мышц после физических нагрузок",
            "улучшение осанки за счёт расслабления перенапряжённых зон",
            "стимуляция кровообращения и лимфотока",
            "снижение отёчности и чувства «забитости» мышц"
        ]
    },
    {
        kind: "h",
        text: "Почему именно шарик для МФР"
    },
    {
        kind: "p",
        text: "МФР-шарик — один из самых удобных инструментов для самомассажа. Его главная особенность — точечное воздействие. В отличие от ролла, шарик позволяет глубже проработать труднодоступные зоны: область лопаток, глубокие мышцы ягодиц, шею и трапеции, стопы, поясницу. Благодаря компактному размеру шарик можно использовать дома, в зале и даже в поездках."
    },
    {
        kind: "h",
        text: "Кому подходит МФР"
    },
    {
        kind: "ul",
        items: [
            "людям с сидячей работой",
            "тем, кто испытывает боли в спине и шее",
            "спортсменам и активно тренирующимся",
            "тем, кто хочет улучшить гибкость и подвижность",
            "девушкам, работающим над качеством тела и уменьшением отёков"
        ]
    },
    {
        kind: "h",
        text: "Как правильно делать МФР с шариком"
    },
    {
        kind: "ul",
        items: [
            "Найдите болезненную или напряжённую точку",
            "Медленно перенесите вес тела на шарик",
            "Задержитесь на точке 20–60 секунд",
            "Дышите глубоко и расслабляйтесь",
            "После уменьшения боли переходите к следующей зоне"
        ]
    },
    {
        kind: "p",
        text: "Важно: не нужно кататься быстро или через сильную боль. МФР работает через осознанное давление и расслабление."
    },
    {
        kind: "h",
        text: "Противопоказания"
    },
    {
        kind: "ul",
        items: [
            "острые воспаления",
            "травмы и повреждения тканей",
            "варикозное расширение вен в зоне воздействия",
            "кожные заболевания"
        ]
    },
    {
        kind: "p",
        text: "МФР с шариком — простой и доступный способ улучшить состояние тела, убрать зажимы и ускорить восстановление без посещения массажиста. Всего 5–10 минут в день помогают снизить боль, повысить подвижность и улучшить общее самочувствие."
    },
    {
        kind: "p",
        text: "Если вы ищете эффективный способ самомассажа, восстановления мышц и улучшения гибкости — МФР с шариком станет одним из самых полезных инструментов в вашей тренировочной и повседневной рутине."
    }
];

const bandBlocks: WorkoutBlock[] = [
    { kind: "p", text: "Хочешь подтянутое, сильное тело без зала и сложного оборудования?" },
    { kind: "p", text: "Эта фулл боди тренировка с резинкой — идеальный вариант." },
    {
        kind: "p",
        text: "Всего одна тренировка включает всё: ягодицы, ноги, спину, руки. Резинка даёт постоянное напряжение, за счёт чего мышцы включаются глубже и работают эффективнее, даже без больших весов."
    },
    { kind: "h", text: "Это формат, который реально работает:" },
    {
        kind: "ul",
        items: [
            "помогает подтянуть тело и сделать его более упругим",
            "усиливает тонус мышц",
            "подходит как новичкам, так и тем, кто уже тренируется",
            "можно делать дома, в зале или даже на отдыхе"
        ]
    },
    { kind: "p", text: "Просто включай видео и делай вместе со мной. Твоё тело очень быстро скажет спасибо." }
];

const workouts: Record<string, WorkoutEntry> = {
    "5973": {
        title: "Миофасциальный релиз с большим МФР шариком FitMi от Viksi666",
        videoUrl: "https://viksi.fra1.cdn.digitaloceanspaces.com/IMG_5973.MP4",
        blocks: mfrBlocks,
        seoDescription: "МФР с большим шариком FitMi помогает снять мышечные зажимы, улучшить подвижность и ускорить восстановление после нагрузок. Техника точечного давления на триггерные точки."
    },
    "5981": {
        title: "Миофасциальный релиз с малым МФР шариком FitMi от Viksi666",
        videoUrl: "https://viksi.fra1.cdn.digitaloceanspaces.com/IMG_5981.MP4",
        blocks: mfrBlocks,
        seoDescription: "МФР с малым шариком FitMi — эффективный самомассаж для снятия зажимов, расслабления мышц и улучшения гибкости. Работает через аккуратное точечное воздействие."
    },
    "5982": {
        title: "Фулл Боди тренировка с резинкой FitMi от Viksi666",
        videoUrl: "https://viksi.fra1.cdn.digitaloceanspaces.com/IMG_5982.MP4",
        blocks: bandBlocks,
        seoDescription: "Фулл боди тренировка с резинкой FitMi: постоянное напряжение помогает глубже включать мышцы и подтянуть тело. Делай дома или в зале — без сложного оборудования."
    }
};

const WorkoutPage: React.FC = () => {
    const { workoutId } = useParams();
    const { t } = useTranslation();

    const workout = workoutId ? workouts[workoutId] : undefined;

    const path = useMemo(() => {
        if (!workout) return [];

        return [
            {
                title: t("nav_home"),
                link: "/"
            },
            {
                title: workout.title
            }
        ];
    }, [t, workout]);

    if (!workout) return <NotFoundPage />;

    return (
        <div className="page-wrapper">
            <Header />
            <div className="light_bg">
                <section className="workout-page">
                    <div className="container">
                        <Seo title={workout.title} description={workout.seoDescription} />
                        <Breadcrumb path={path} />
                        <h1 className="workout-title">{workout.title}</h1>
                        <div className="workout-player-wrapper">
                            {
                                workout.videoUrl
                                    ? <ReactPlayer
                                        className="workout-player"
                                        url={workout.videoUrl}
                                        width="100%"
                                        height="100%"
                                        controls={true}
                                        playsinline={true}
                                    />
                                    : <div className="workout-video-placeholder">
                                        Видео ещё не подключено. Добавьте ссылку в `src/pages/Workout.tsx`.
                                    </div>
                            }
                        </div>
                        <div className="workout-content">
                            {workout.blocks.map((block, index) => {
                                if (block.kind === "h") {
                                    return <h3 key={`workout-block-${index}`} className="workout-section-title">{block.text}</h3>
                                }

                                if (block.kind === "ul") {
                                    return (
                                        <ul key={`workout-block-${index}`} className="workout-list">
                                            {block.items.map((item, liIndex) => (
                                                <li key={`workout-list-${index}-${liIndex}`}>{item}</li>
                                            ))}
                                        </ul>
                                    )
                                }

                                return <p key={`workout-block-${index}`}>{block.text}</p>
                            })}
                        </div>
                    </div>
                </section>
            </div>
            <Social light />
        </div>
    );
};

export default WorkoutPage;
